import { render, staticRenderFns } from "./yearManagement.vue?vue&type=template&id=981f05c0"
import script from "./yearManagement.vue?vue&type=script&lang=js"
export * from "./yearManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('981f05c0')) {
      api.createRecord('981f05c0', component.options)
    } else {
      api.reload('981f05c0', component.options)
    }
    module.hot.accept("./yearManagement.vue?vue&type=template&id=981f05c0", function () {
      api.rerender('981f05c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/basic/yearManagement.vue"
export default component.exports